(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var cw_clock_color_stopped = 'salmon';
var cw_clock_color_colorup = 'yellow';
var cw_clock_color_break = 'orange';
var cw_clock_color_field = '#fafbfa';
var duration_factor = 60;
var clock_level_field;
var ltime_value_item, level_value_item;
var current_field_item, current_value_item;
var next_field_item, next_value_item;
var time_calc;
var timer_interval;
var cw_tt_clock_stop;
var cw_tt_status;
var cw_tt_statuscolorup;
var cw_tt_statusbreaking;
var cw_tt_level;
var cw_tt_ltime;
window.addEventListener("DOMContentLoaded", function () {
  var detailsList;
  if (detailsList = document.querySelectorAll('.cw-pulldown')) {
    for (var i = 0; i < detailsList.length; i++) {
      detailsList[i].addEventListener('click', function (event) {
        event.preventDefault();
        var currentElement = event.currentTarget;
        var ident = currentElement.id.substr(6);
        var toggleElement;
        var split = ident.split('_', 2);
        var list = split[0];
        var id = split[1];
        if (document.querySelector('#cw_accordion_' + list)) {
          for (var i = 0; i < detailsList.length; i++) {
            if (toggleElement = document.querySelector('#cw_tr_details_' + list + '_' + i)) {
              if (i == id) {
                toggleElement.classList.toggle('cw-show');
              } else {
                toggleElement.classList.remove('cw-show');
              }
            }
          }
        } else {
          toggleElement = document.querySelector('#cw_tr_details_' + ident);
          if (toggleElement) {
            toggleElement.classList.toggle('cw-show');
          }
        }
      });
    }
  }
  if (clock_level_field = document.getElementById('cw_clock_level_field')) {
    time_calc = getSecs();
    level_value_item = clock_level_field.querySelector('#cw_clock_level');
    ltime_value_item = clock_level_field.querySelector('#cw_clock_ltime');
    current_field_item = document.getElementById('cw_clock_current_field');
    current_value_item = document.getElementById('cw_clock_current_value');
    next_field_item = document.getElementById('cw_clock_next_field');
    next_value_item = document.getElementById('cw_clock_next_value');
    cw_tt_status = cw_tt['status'];
    cw_tt_statuscolorup = cw_tt['statuscolorup'];
    cw_tt_statusbreaking = cw_tt['statusbreaking'];
    cw_tt_status = cw_tt['status'];
    cw_tt_level = cw_tt['level'];
    cw_tt_ltime = cw_tt['ltime'];
    if (8 == cw_tt_status) {
      calcClock(cw_update_timediff);
    }
    printLevelTimer();
    printCurrentField();
    printNextField();
    timer_interval = setInterval(timer, 1000);
  }
  var tables = document.getElementsByClassName("cw-search-table");
  Array.from(tables).forEach(function (element) {
    var index = element.id.substring(element.id.length - 1);
    var inputId = 'cw-search-input-' + index;
    var tableId = 'cw-search-table-' + index;
    var buttonId = 'cw-clear-input-button-' + index;
    var field = document.getElementById(inputId);
    var button = document.getElementById(buttonId);
    var searchVar = 'cw_search_value_' + index;
    var searchDo = eval("typeof " + searchVar + " !== 'undefined'");
    if (field && button) {
      field.addEventListener('keyup', searchLeaderboard(inputId, tableId, buttonId));
      field.addEventListener('keydown', function (event) {
        if (event.key == "Escape") {
          field.value = "";
          searchLeaderboard(inputId, tableId, buttonId)();
        }
      });
      button.addEventListener('click', function (event) {
        field.value = "";
        searchLeaderboard(inputId, tableId, buttonId)();
      });
      if (searchDo) {
        var searchValue = eval(searchVar);
        if (searchValue.length > 0) {
          field.value = searchValue;
          searchLeaderboard(inputId, tableId, buttonId)();
        }
      }
    }
  });
});
function getSecs() {
  return Math.floor(new Date().getTime() / 1000);
}
function calcClock(diff) {
  var changed = false;
  if (cw_tt_ltime > diff) {
    cw_tt_ltime -= diff;
  } else if (null !== cw_tt_levels) {
    var td = diff;
    while (td > cw_tt_ltime && cw_tt_level <= cw_tt_levels.length) {
      td -= cw_tt_ltime;
      setNextLevel();
      changed = true;
    }
    if (td == cw_tt_ltime) {
      setNextLevel();
      changed = true;
    } else {
      cw_tt_ltime -= td;
    }
  }
  return changed;
}
function timer() {
  if (cw_tt_clock_stop) {
    return;
  }
  if (8 == cw_tt_status) {
    var secs = getSecs();
    var diff = secs - time_calc;
    time_calc = secs;
    if (calcClock(diff)) {
      printCurrentField();
      printNextField();
    }
    printLevelTimer();
  }
}
function setNextLevel() {
  var lidx = cw_tt_level - 1;
  var l;
  if (cw_tt_statuscolorup) {
    cw_tt_statuscolorup = false;
    l = cw_tt_levels[lidx];
    if (l['breakduration'] > 0) {
      cw_tt_statusbreaking = true;
      cw_tt_ltime = l['breakduration'] * duration_factor;
    } else {
      if (lidx + 1 < cw_tt_levels.length) {
        l = cw_tt_levels[lidx + 1];
        cw_tt_ltime = l['duration'] * duration_factor;
      } else {
        cw_tt_clock_stop = true;
      }
      cw_tt_level++;
    }
  } else if (cw_tt_statusbreaking) {
    cw_tt_statusbreaking = false;
    if (lidx + 1 < cw_tt_levels.length) {
      l = cw_tt_levels[lidx + 1];
      cw_tt_ltime = l['duration'] * duration_factor;
    } else {
      cw_tt_clock_stop = true;
    }
    cw_tt_level++;
  } else {
    l = cw_tt_levels[lidx];
    if (l['colorupduration'] > 0) {
      cw_tt_statuscolorup = true;
      cw_tt_ltime = l['colorupduration'] * duration_factor;
    } else if (l['breakduration'] > 0) {
      cw_tt_statusbreaking = true;
      cw_tt_ltime = l['breakduration'] * duration_factor;
    } else {
      if (lidx + 1 < cw_tt_levels.length) {
        l = cw_tt_levels[lidx + 1];
        cw_tt_ltime = l['duration'] * duration_factor;
      } else {
        cw_tt_clock_stop = true;
      }
      cw_tt_level++;
    }
  }
}
function printLevelTimer() {
  var color;
  var level;
  var ltime;
  var lidx = cw_tt_level - 1;
  if (cw_tt_status & (32 | 64)) {
    // Clock stopped and seating
    color = cw_clock_color_stopped;
  } else if (cw_tt_status & 128) {
    // Time out
    color = cw_clock_color_field;
  } else if (cw_tt_statuscolorup) {
    color = cw_clock_color_colorup;
  } else if (cw_tt_statusbreaking) {
    color = cw_clock_color_break;
  } else {
    color = cw_clock_color_field;
  }
  if (null === cw_tt_levels || lidx < 0 || lidx >= cw_tt_levels.length) {
    level = "";
    ltime = "";
  } else {
    level = cw_tt_level;
    ltime = formattedTimer(cw_tt_ltime);
  }
  level_value_item.innerHTML = level;
  ltime_value_item.innerHTML = ltime;
  clock_level_field.setAttribute('style', "background:" + color + ";");
}
function printCurrentField() {
  var lidx;
  var out;
  var color;
  if (cw_tt_statuscolorup) {
    out = "Color-Up";
    color = cw_clock_color_colorup;
  } else if (cw_tt_statusbreaking) {
    out = "Break";
    color = cw_clock_color_break;
  } else {
    lidx = cw_tt_level - 1;
    out = formattedBlinds(lidx);
    color = cw_clock_color_field;
  }
  current_value_item.innerHTML = out;
  current_field_item.setAttribute('style', "background:" + color + ";");
}
function printNextField() {
  var l;
  var out;
  var color;
  var lidx = cw_tt_level - 1;
  if (null !== cw_tt_levels && lidx < cw_tt_levels.length) {
    l = cw_tt_levels[lidx];
    if (cw_tt_statuscolorup) {
      if (l['breakduration'] > 0) {
        out = "Break (" + l['breakduration'] + " mins)";
        color = cw_clock_color_break;
      } else {
        out = formattedBlinds(lidx + 1);
        color = cw_clock_color_field;
      }
    } else if (cw_tt_statusbreaking) {
      out = formattedBlinds(lidx + 1);
      color = cw_clock_color_field;
    } else if (l['colorupduration'] > 0) {
      out = "Color-Up (" + l['colorupduration'] + " mins)";
      color = cw_clock_color_colorup;
    } else if (l['breakduration'] > 0) {
      out = "Break (" + l['breakduration'] + " mins)";
      color = cw_clock_color_break;
    } else {
      out = formattedBlinds(lidx + 1);
      color = cw_clock_color_field;
    }
  } else {
    out = "-";
    color = cw_clock_color_field;
  }
  next_value_item.innerHTML = out;
  next_field_item.setAttribute('style', "background:" + color + ";");
}
function formattedBlinds(lidx) {
  if (null === cw_tt_levels || 0 > lidx || lidx >= cw_tt_levels.length) {
    return "-";
  }
  var l = cw_tt_levels[lidx];
  var out = "";
  var v;
  if ('smallblind' in l && (v = l['smallblind']) > 0) {
    out += v;
  }
  if ('bigblind' in l && (v = l['bigblind']) > 0) {
    out += " / " + v;
  }
  if ('ante' in l && (v = l['ante']) > 0) {
    out += " Ante " + v;
  }
  if ('bringin' in l && (v = l['bringin']) > 0) {
    out += " Bring-In " + v;
  }
  return out;
}
function formattedTimer(value) {
  var m = Math.floor(value / 60);
  var s = value - m * 60;
  var out = String(m).padStart(2, '0') + ":" + String(s).padStart(2, '0');
  return out;
}
function searchLeaderboard(inputId, tableId, buttonId) {
  return function () {
    var input, filter, button, table, tr, td, attr, i, j, txtValue, found, seps;
    input = document.getElementById(inputId);
    filter = input.value.toUpperCase();
    table = document.getElementById(tableId);
    tr = table.querySelectorAll("tbody tr.cw-tr-searchable");
    seps = table.querySelectorAll("tbody tr.cw-tr-seps-drawer");
    button = document.getElementById(buttonId);
    button.style.display = filter.length > 0 ? "inline" : "none";
    // Loop through all the table rows and hide those that don't match the search query
    for (i = 0; i < tr.length; i++) {
      found = "none";
      attr = tr[i].getAttribute('mdno');
      if (!!attr && attr.toUpperCase() == filter) {
        found = "";
      } else {
        td = tr[i].getElementsByTagName("td");
        for (j = 0; j < td.length; j++) {
          txtValue = td[j].textContent || td[j].innerText;
          if (txtValue.toUpperCase().indexOf(filter) > -1) {
            found = "";
            break; // Show the row and move to the next one
          }
        }
      }
      if (i < tr.length) {
        tr[i].style.display = found;
      }
      if (i < seps.length) {
        seps[i].style.display = found;
      }
    }
  };
}

},{}]},{},[1]);
